// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__OtTrb","innerLoader":"styles_innerLoader__2fxAg","animation":"styles_animation__3_-G9"};